module.exports = __webpack_public_path__ + "static/img/sxstl_banner.67cc9a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/commission/sxstl_banner.png
// module id = JJR5
// module chunks = 70